import * as React from 'react';
import { observable } from "mobx";
import { observer } from "mobx-react";
import { resolve } from "inversify-react";
import autobind from 'autobind-decorator';
import { Button, Modal } from 'antd';

import { TextView } from '../text.view';
import { TabLanguageController } from "./tab-language.controller";
import { ToastNotifications } from '../toast';
import { ZuluIcon } from 'src/app/shared/icon';

interface TabLanguageInlineViewProps {
    mode: ControlMode;
    dynamicProperties: TabLanguageModel[];
    setBusy: (isBusy: boolean) => void;
    onChange?: (newVal: any) => void;
    model?: Model;
}

@observer
export class TabLanguageInlineView extends React.Component<TabLanguageInlineViewProps, any> {
    constructor(props) {
        super(props);
    }

    @resolve
    public toast: ToastNotifications;

    @observable
    showDialog = false;

    render() {
        const model = this.props.dynamicProperties[0];
        return <div>
            <TextView mode={this.props.mode}
                label={null}
                required={model.required}
                value={model.dynamicProperties['en']}
                onChanged={newVal => {
                    model.dynamicProperties['en'] = newVal;
                    if (this.props.onChange) {
                        this.props.onChange(model.dynamicProperties);
                    }
                }}
				addonAfter={<ZuluIcon type='flag' onClick={() => this.showDialog = true} className='cursor' />}
            />
            {
                this.showDialog && <Modal
                    visible={this.showDialog}
                    title='Edit'
                    maskClosable={false}
                    footer={[
                        <Button key='confirm' type="primary" onClick={this.dismiss}>Confirm</Button>,
                        <Button key='cancel' onClick={this.dismiss}>Cancel</Button>
                    ]}
                >
                    <TabLanguageController
                        dynamicProperties={this.props.dynamicProperties}
                        mode={this.props.mode}
                        setBusy={this.props.setBusy}
                        isRichTextBox={false}
                        model={this.props.model}
                        onChanged={newVal => {
                            if (this.props.onChange) {
                                this.props.onChange(model.dynamicProperties);
                            }
                        }}
                    />
                </Modal>
            }
        </div>;
    }

    @autobind
    private async confirmDialog(ev?: React.MouseEvent<HTMLButtonElement>) {
        var errors = await this.props.model.validate(false);
        if (errors.length == 0) {
            this.dismiss();
        } else {
            this.toast.showToast('Validation error!', errors.map(o => o.text), 'error');

        }
    }

    @autobind
    private dismiss(): void {
        this.showDialog = false;
    }
}



// WEBPACK FOOTER //
// ./src/core/ui/language/tab-language-inline.view.tsx